import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export const { thunk: deleteListingThunk, slice: deleteListingSlice } = getThunkAndSlice<
	{
		CompanyName: string;
		DeleteReason: string;
		ItemIds: Array<number>;
	},
	typeof initialState
>({
	initialState,
	path: "/api/System/DeleteTickets",
	method: "post",
});
